import { useEffect, useState } from 'react';
import { trackEventRaw } from '../utils/track';

/* ══════════════════════════════════════════════════════════════════════════
   LoadingGate — teljes képernyős betöltő, watchdoggal
   ─────────────────────────────────────────────────────────────────────────
   A végtelen betöltés (a landing repó docs/vegtelen-betoltes-2026-09.md-je)
   tünetét kezeli: ha a betöltés 10 másodpercnél tovább tart, a spinner helyett
   hibaüzenet és "Újratöltés" gomb jelenik meg, plusz loading_stuck esemény.

   MIÉRT KELL a .catch()-ek MELLETT is: ha a getSession() nem dob hibát, hanem
   HOLTPONTBA kerül, nincs mit elkapni — a .then() és a .catch() sem fut le
   soha. Ilyenkor csak egy időzítő segít.

   A mérés trackEventRaw-val megy, NEM a supabase-js-en át: az ugyanarra az
   auth lockra várna, ami épp beragadt.
   ══════════════════════════════════════════════════════════════════════════ */

const STUCK_AFTER_MS = 10000;

export default function LoadingGate({ page, stage, message = 'Betöltés…' }) {
  const [stuck, setStuck] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      setStuck(true);
      trackEventRaw('loading_stuck', { page, stage, seconds: STUCK_AFTER_MS / 1000 });
    }, STUCK_AFTER_MS);
    return () => clearTimeout(t);
  }, [page, stage]);

  if (!stuck) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner">◈</div>
        <div>{message}</div>
      </div>
    );
  }

  return (
    <div className="loading-screen" style={{ textAlign: 'center', padding: 24 }}>
      <div style={{ fontSize: 40, marginBottom: 16 }}>⏳</div>
      <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 10 }}>
        A betöltés tovább tart a szokásosnál
      </div>
      <div style={{ fontSize: 14, opacity: 0.6, lineHeight: 1.7, maxWidth: 420, marginBottom: 22 }}>
        Előfordul, hogy a kapcsolat elakad. Töltsd újra az oldalt — ha másodszor
        sem megy, írj a hello@web3kurzus.hu címre.
      </div>
      <button
        onClick={() => window.location.reload()}
        style={{
          background: '#00D2C8', color: '#0a0f1e', border: 'none', borderRadius: 100,
          padding: '13px 30px', fontSize: 15, fontWeight: 700, cursor: 'pointer',
          fontFamily: 'inherit',
        }}
      >
        Újratöltés →
      </button>
    </div>
  );
}
